import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/global/global.css'
import { resetForm, getTableDictValue, getUserName, getDeptName, openMenu } from '@/common/utils/utils'
import '@/directive/permission.js'
import Print from 'vue-print-nb'


Vue.use(Print)
Vue.config.productionTip = false

Vue.prototype.resetForm = resetForm
Vue.prototype.getTableDictValue = getTableDictValue
Vue.prototype.getUserName = getUserName
Vue.prototype.getDeptName = getDeptName
Vue.prototype.openMenu = openMenu

router.beforeEach((to, from, next) => {
  const token = store.getters.getUser.token
  if (to.path === '/logout') {
    store.dispatch('asyncUpdateUser', {
      token: ''
    })
    return next('/login')
  } else if (to.path === '/login') {
    if (token !== '') {
      return next('/main')
    }
  } else {
    if (token === '') {
      return next('/login')
    }
  }
  next()
})

Vue.prototype.getNowFormatDate = function () {
  var date = new Date()
  var seperator1 = '-'
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
